import React from "react";
import { Col, Row } from "react-bootstrap";
import classNames from "classnames";
import PageTitle from "../../../components/Elements/PageTitle/PageTitle.tsx";
import { IconGraduationCap } from "../../../components/Icon/Icon.tsx";
import { PageContentFluid } from "../../../components/Elements/Elements.tsx";
import GetTitleForProche from "../../../../commun/Utils/FonctionUtils.tsx";
import ListeRessourcesProche from "../../../components/Ressource/ListeRessourceProche.tsx";
import LigneEcoute from "../../../../commun/components/LigneEcoute/LigneEcoute.tsx";
import { useAppContext } from "../../../components/App/AppProvider.tsx";
import url from "../../../module/fetch.tsx";
import CodeLivretAccueil from "../../../../commun/GlobalConstants.tsx";
import styles from "./RessourceProche.module.css";

const RessourcesProche = () => {
  const { user }: any = useAppContext();
  const { isProcheFinDeVie }: any = user;

  return (
    <PageContentFluid>
      <Row>
        <PageTitle title={GetTitleForProche()} icon={<IconGraduationCap />} />
      </Row>
      <Row className={"m-0 p-0"}>
        <Col xs={12} xl={5} xxl={4} className={"order-2 order-xl-1"}>
          <h2
            className={classNames(
              styles.subtitle,
              "text-secondary-100 my-3 mx-0",
            )}
          >
            Ligne d&apos;écoute Famiréa
          </h2>
          <p className={classNames(styles.text, "mx-2 text-text-color")}>
            Vous avez une question sur la réanimation, vous souhaitez être
            orienté ou être soutenu ? N&apos;hésitez pas à appeler la ligne
            d&apos;écoute Famiréa.
          </p>
          <LigneEcoute />

          {isProcheFinDeVie && (
            <p className={classNames(styles.subline, "text-text-color m-2")}>
              Avez-vous téléchargé{" "}
              <a
                href={
                  url`/api/public/ressource/telecharger-ressource/` +
                  CodeLivretAccueil
                }
              >
                le livret d’accueil ?
              </a>
            </p>
          )}
        </Col>
        <Col xs={12} xl={7} xxl={8} className={"order-1 order-xl-2"}>
          <Row>
            <Col xs={12} className={"m-0 p-0"}>
              <ListeRessourcesProche />
            </Col>
          </Row>
        </Col>
      </Row>
    </PageContentFluid>
  );
};

export default RessourcesProche;
